import { render } from "./read-only-proposal-details.vue?vue&type=template&id=49e0e556&scoped=true"
import script from "./read-only-proposal-details.vue?vue&type=script&lang=js"
export * from "./read-only-proposal-details.vue?vue&type=script&lang=js"

import "./read-only-proposal-details.vue?vue&type=style&index=0&id=49e0e556&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49e0e556"]])

export default __exports__